import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa oceny',
      type: 'string',
      fieldRequired: true
    },
    documentId: {
      name: 'Oceniany wniosek',
      type: 'number',
      fieldRequired: true
    },
    profileId: {
      name: 'Oceniający',
      type: 'number',
      fieldRequired: true
    },
    data: {
      title: 'Dane oceny',
      properties: {
        assessments: {
          type: 'array',
          title: 'Wartości oceny',
          items: {
            title: 'Wartość oceny',
            properties: {
              criterionId: {
                type: 'number',
                title: 'Kryterium oceny'
              },
              criterionType: {
                type: 'string',
                computed: true,
                aggregate: {
                  array: '$external.criterions',
                  when: '$item.id === this.criterionId',
                  func: 'first',
                  property: 'type'
                }
              },
              criterionMaximum: {
                type: 'number',
                computed: true,
                aggregate: {
                  array: '$external.criterions',
                  when: '$item.id === this.criterionId',
                  func: 'first',
                  property: 'maximum'
                }
              },
              passed: {
                type: 'number',
                title: 'Czy kryterium zostało spełnione',
                default: null,
                enum: [1, 2, 3, 4, null]
              },
              value: {
                type: 'number',
                title: 'Liczba punktów za kryterium',
                fieldRequired: "this.criterionType === 'SCORE'",
                maximum: 'this.criterionMaximum'
              },
              description: {
                type: 'string',
                title: 'Uwagi'
              }
            }
          }
        }
      }
    }
  },
  allOf: [validationMessages]
};
